(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('UserManagementDetailController', UserManagementDetailController);

    UserManagementDetailController.$inject = ['$stateParams', 'User', 'Principal'];

    function UserManagementDetailController ($stateParams, User, Principal) {
        var vm = this;

        vm.load = load;
        vm.user = {};
        vm.isAdmin = false;
        
        vm.load($stateParams.login);

        Principal.hasAuthority('ROLE_ADMIN')
			.then(function (result) {
            	if (result) {
                	vm.isAdmin = true;
        		}
		});

        function load (login) {
            User.get({login: login}, function(result) {
                vm.user = result;
            });
        }

    }
})();
